import React from 'react'
import { trimValues } from 'lib/helpers/forms'

const withEventHandlers = WrappedComponent => {
  return props => {
    const {
      createCamper, // via withMutation
      form: reduxForm, // via withRedux
      setCamperFormField // via redux actions
    } = props

    const form = trimValues(reduxForm)

    // perform GraphQL mutation
    const handleClickSubmit = e => {
      const buildAllergyInput = camperAllergy => {
        const { id, name, severe, food, custom } = camperAllergy
        return { id, name, severe, food, custom }
      }

      e.preventDefault()
      createCamper({
        variables: {
          input: {
            // personal info
            firstName: form.firstName,
            lastName: form.lastName,
            gender: form.gender,
            birthdate: form.birthdate,
            school: form.school,
            parentNotes: form.parentNotes,
            // allergies and diet
            camperAllergies: form.camperAllergies.map(buildAllergyInput),
            hasDietaryRestrictions: form.hasDietaryRestrictions,
            hasFoodAllergies: form.hasFoodAllergies,
            hasNonFoodAllergies: form.hasNonFoodAllergies,
            foodAllergyNotes: form.foodAllergyNotes,
            nonFoodAllergyNotes: form.nonFoodAllergyNotes,
            dietaryRestrictions: form.dietaryRestrictions,
            dietaryRestrictionsOther: form.dietaryRestrictionsOther,
            sitsSeparately: form.sitsSeparately,
            // medical
            medications: form.medications,
            medicalConditions: form.medicalConditions,
            immunizations: form.immunizations,
            tetanusShotDate: form.tetanusShotDate,
            doctorName: form.doctorName,
            doctorPhoneNumber: form.doctorPhoneNumber
          }
        }
      })
    }

    const updateArrayField = (field, box, checked) => {
      if (checked) {
        if (!form[field].includes(box)) {
          setCamperFormField(field, [...form[field], box])
        }
      } else {
        setCamperFormField(
          field,
          form[field].filter(item => item !== box)
        )
      }
    }

    return (
      <WrappedComponent
        onClickSubmit={handleClickSubmit}
        updateArrayField={updateArrayField}
        {...props}
      />
    )
  }
}

export default withEventHandlers
